declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";

import { Router, ActivatedRoute } from '@angular/router';

import * as alertFunctions from '../../../../shared/data/sweet-alerts';


declare var require: any;

import { ApiResponseModel } from '../../../../../../src/app/ncs/models/api_response_model';
import { NgbModal, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { ActorService } from '../../../../../../src/app/ncs/services/actor.service';
import { routerTransition } from '../../../../../../src/app/ncs/animations/router.animations';
import { NgbAddBill } from './modal/addbill.modal';
import { NgbPayBillModal } from './paybill.modal';
import { PatientInfoByFormattedCodeController, ServicesByCategoryCodeController, ServicesByCategoryCodeRequest, NewBillData, SaveBillItemsInfoRequest, OrderData, SaveiahOrderRequest, DoctorsListController, DoctorsListRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { PatientInfoByFormattedCodeRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { AppData } from '../../../../../../src/app/ncs/models/appdata';
import { SpinnerService } from '../../../../../../src/app/ncs/services/spinner.service';
import { NGXToastrService } from '../../../../../../src/app/shared/services/toastr.service';
import { Servicebillpipe } from '../../../pipes/actors/actorIdentity.pipes';
import { NgbPaymentModal } from './modal/payment.modal';
import { NgbSearchProviderModal } from '../ivf/ivfworkbench/searchprovider.modal';
import { PrescribingDoctor, ReferringDoctor, BillDetails, BillItemDeleted } from '../_MasterClasses/BillingClasses';




@Component({
    selector: 'iohreceipt',
    templateUrl: './iohreceipt.component.html',
    styleUrls: ['./iohreceipt.component.scss']
    , animations: [routerTransition()]
})

export class IOHReceiptComponent implements OnInit {


    public ApiResData: ApiResponseModel;
    @Input() FormattedCode: string;

    public ActorCode: number = 0;
    //public FormattedCode: number = 0;
    public isNew: boolean = false;
    public isEdit: boolean = false;
    public IsExpand: boolean = true;
    public Showarrow: boolean = false;
    public ShowList: boolean = true;
    public ShowPatientDetails: boolean = false;
    public receipt: boolean = true;
    public opbilling: boolean = false;
    public Add: boolean = true;
    public Edit: boolean = false;
    public isRequesting: boolean = false;
    public cash: boolean = false;
    public card: boolean = false;
    public cheque: boolean = false;
    public demanddraft: boolean = false;
    public paytm: boolean = false;
    public FormattedCodedata: any;
    public OrderType: any;
    public TotalBill: number;
    public Prescribername: any;
    public Prescribercode: number = 0;
    public Prescriberdesg: any;
    public Refname: any = "";
    public Refcode: number = 0;
    public Refdesg: any = "";
    public NetPayable: number;
public Discount:number=0;
    public BranchName: string;
    public Date: Date;
    searchTitle: string;
    public SelectedPrescriber: PrescribingDoctor[];
    public SelectedReferral: ReferringDoctor[];
    CurrentSaveBillItemsInfoRequest: SaveBillItemsInfoRequest;
    CurrentSaveiahOrderRequest: SaveiahOrderRequest;
    CurrentPatientInfoByFormattedCodeController: PatientInfoByFormattedCodeController[];
    SelectedPatientFormattedCode: PatientInfoByFormattedCodeController;
    CurrentPatientInfoByFormattedCodeRequest: PatientInfoByFormattedCodeRequest;



    LoadPatients(FormattedCode: string) {
        this.CurrentPatientInfoByFormattedCodeRequest = new PatientInfoByFormattedCodeRequest();

        //alert('Checking Forma ' + this.FormattedCode);



        this.CurrentPatientInfoByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

        this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = FormattedCode;
        this.CurrentPatientInfoByFormattedCodeRequest.Branch = 0;
        this.CurrentPatientInfoByFormattedCodeRequest.ConditionalOperator = 10;
        this.CurrentPatientInfoByFormattedCodeRequest.FromDate = new Date();
        this.CurrentPatientInfoByFormattedCodeRequest.ToDate = new Date();
        this.CurrentPatientInfoByFormattedCodeRequest.IsToday = true;
        this.CurrentPatientInfoByFormattedCodeRequest.IsDuration = false;
        this.CurrentPatientInfoByFormattedCodeRequest.SearchText = "";
        this.GetPatientInfoByFormattedCodeController();
    }
    GetPatientInfoByFormattedCodeController() {
        this.StartRefreshing();


        this.actorservice.GetPatientInfoByFormattedCodeController(this.CurrentPatientInfoByFormattedCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentPatientInfoByFormattedCodeController = this.ApiResData.Result;
                    this.SelectedPatientFormattedCode = this.CurrentPatientInfoByFormattedCodeController[0];
                    this.LoadDoctorsList();
                    this.stopRefreshing();
                    //this.LoadSign();
                    //this.LoadPatientCounsellingPlansIfAny();



                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }

    constructor(private router: Router,
        private actorservice: ActorService,
        private route: ActivatedRoute, private loaderService: SpinnerService,
        private modalService: NgbModal,
        private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService,
        private filter: Servicebillpipe,


    ) { }

    ngOnInit() {


        this.FormattedCodedata = this.route.snapshot.paramMap.get('FormattedCodedata');
        this.OrderType = this.route.snapshot.paramMap.get('OrderType');
        // alert(this.FormattedCodedata);
        this.LoadPatients(this.FormattedCodedata);
        this.LoadServicesByCategory();
        this.CurrentSaveBillItemsInfoRequest = new SaveBillItemsInfoRequest();
        this.CurrentSaveBillItemsInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.CurrentSaveiahOrderRequest = new SaveiahOrderRequest();
        this.CurrentSaveiahOrderRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    }

    CurrentServicesByCategoryCodeGetRequest: ServicesByCategoryCodeRequest;
    CurrentServicesByCategoryCodeController: ServicesByCategoryCodeController[];
    LoadServicesByCategory() {

        this.CurrentServicesByCategoryCodeGetRequest = new ServicesByCategoryCodeRequest();
        //this.pdata2 = this.ServicesByCategoryCodeController;
        this.CurrentServicesByCategoryCodeGetRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.CurrentServicesByCategoryCodeGetRequest.ServiceCategory = "0";
        this.CurrentServicesByCategoryCodeGetRequest.BranchCode = AppData.Instance().SelectedBranchCode;
        this.CurrentServicesByCategoryCodeGetRequest.ConditionalOperator = 10;
        this.CurrentServicesByCategoryCodeGetRequest.PrescriberCode =0;
        this.CurrentServicesByCategoryCodeController = new Array<ServicesByCategoryCodeController>();
        this.pdata = this.CurrentServicesByCategoryCodeController;
        this.GetServicesByCategoryCodeController();

    }
    GetServicesByCategoryCodeController() {
        this.StartRefreshing();
        this.actorservice.GetServicesByCategoryCodeController(this.CurrentServicesByCategoryCodeGetRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                //alert(this.ApiResData.ErrorData);
                if (!this.ApiResData.hasError) {

                    this.CurrentServicesByCategoryCodeController = this.ApiResData.Result;
                    this.pdata = this.CurrentServicesByCategoryCodeController;

                    this.stopRefreshing();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );

    }

    CurrentDoctorsListController: DoctorsListController[];
    CurrentDoctorsListRequest: DoctorsListRequest;

    LoadDoctorsList() {
        this.CurrentDoctorsListController = new Array<DoctorsListController>();

        this.CurrentDoctorsListRequest = new DoctorsListRequest();
        // this.pdata = this.CurrentDoctorsListController;
        //this.pdata1 = this.CurrentDoctorsListController;
        this.CurrentDoctorsListRequest.ConditionalOperator = 20;
        this.CurrentDoctorsListRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
        this.CurrentDoctorsListRequest.ProvidersSpecality = "";
        this.CurrentDoctorsListRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetDoctorsListController();
    }
    GetDoctorsListController() {
        this.StartRefreshing();

        this.actorservice.GetDoctorsListController(this.CurrentDoctorsListRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    //alert();
                    this.CurrentDoctorsListController = this.ApiResData.Result;
                    if (this.SelectedPatientFormattedCode.PrimaryDoctor != 'null' && this.SelectedPatientFormattedCode.PrimaryDoctor != '---' ) {
                        this.Prescribercode = this.CurrentDoctorsListController.filter(X => X.DisplayName == this.SelectedPatientFormattedCode.PrimaryDoctor)[0].ProviderCode;
                        //alert(this.Prescribercode)
                        this.Prescriberdesg = this.CurrentDoctorsListController.filter(X => X.DisplayName == this.SelectedPatientFormattedCode.PrimaryDoctor)[0].Specialty;
                        this.Prescribername = this.SelectedPatientFormattedCode.PrimaryDoctor;
                        this.LoadServicesByCategory();
                        this.LoadDoctorPres();
                    }
                    if (this.SelectedPatientFormattedCode.RefDetails != 'null') {
                       // alert("notnull");
                        this.CurrentReferringDoctor = null;
                        this.Refcode = this.SelectedPatientFormattedCode.RefCode;
                        this.Refdesg = "null";
                        this.Refname = this.SelectedPatientFormattedCode.RefDetails;
                        this.LoadDoctorRef();
                    }
                    if (this.SelectedPatientFormattedCode.RefDetails == 'null') {
                       
                        this.Refcode = 0;
                        this.Refdesg = "null";
                        this.Refname = "null";
                        this.LoadDoctorRef();
                    }

                    //this.pdata = this.CurrentDoctorsListController;
                    //this.pdata1 = this.CurrentDoctorsListController;
                    //alert(this.CurrentServiceCategoriesController.length);

                    this.stopRefreshing();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );

    }
    selectedGroupnew: PrescribingDoctor;
    onChange(Event: any) {
        //alert(Event.value);
        if (Event != null) {
            var a = this.CurrentDoctorsListController.filter(X => X.ProviderCode == Event.value)
            //alert(a.length);
            if (a.length > 0) {

                this.Prescribername = a[0].DisplayName;
                this.Prescribercode = a[0].ProviderCode;
                this.Prescriberdesg = a[0].Specialty;
                this.LoadDoctorPres();
                this.LoadServicesByCategory();
                //alert(this.Prescribername);

                //        // alert(this.ActivityDate);
            }
        }
    }
    CurrentPrescribingDoctor: Array<PrescribingDoctor>;
    LoadDoctorPres() {
        // alert(Selectedgroupnew.DoctorName + "," + Selectedgroupnew.DoctorCode);
        if (this.CurrentPrescribingDoctor == null) {
            this.CurrentPrescribingDoctor = new Array<PrescribingDoctor>();
        }
        if (this.CurrentPrescribingDoctor != null) {
            var row = new PrescribingDoctor();
            row.DoctorName = this.Prescribername;
            row.DoctorCode = this.Prescribercode;
            row.Designation = this.Prescriberdesg;
            //row.DoctorName = Selectedgroupnew.DoctorName;
            // row.DoctorCode = Selectedgroupnew.DoctorCode;
            // row.Designation = Selectedgroupnew.Designation;
            this.CurrentPrescribingDoctor.push(row);
        }
    }

    CurrentReferringDoctor: Array<ReferringDoctor>;

    LoadDoctorRef() {
        if (this.CurrentReferringDoctor == null) {
            this.CurrentReferringDoctor = new Array<ReferringDoctor>();
        }
        if (this.CurrentReferringDoctor != null) {
            var row = new ReferringDoctor();
            row.DoctorName = this.Refname;
            row.DoctorCode = this.Refcode;
            row.Designation = this.Refdesg;
            this.CurrentReferringDoctor.push(row);
        }
    }


    BackToProfile() {
        this.ShowList = true;
        this.ShowPatientDetails = false;
        this.Showarrow = false;
    }
    cashdata() {
        this.cash = true;
    }
    carddata() {
        this.card = true;
    }
    chequedata() {
        this.cheque = true;
    }
    demanddraftdata() {
        this.demanddraft = true;
    }
    paytmdata() {
        this.paytm = true;
    }
    pdata: any[];// = this.data;
    listFilter: string;
    ngOnChanges(changes: any) {
        if (JSON.stringify(changes).indexOf("data") != -1)
            this.pdata = this.CurrentServicesByCategoryCodeController;

        this.criteriaChange(this.listFilter);
    }
    criteriaChange(value: any) {
        if (this.filter != null) {
            if (value != '[object Event]') {
                this.listFilter = value;
                //alert(this.listFilter);
                this.pdata = this.filter.transform(this.CurrentServicesByCategoryCodeController,
                    this.listFilter);
            }
        }
    }

    clearData() {
        this.isNew = true;
        this.ShowList = false;

    }
    ExpandData() {
        if (this.IsExpand === true) {
            this.IsExpand = false;
        }
        else {
            this.IsExpand = true;
        }
    }

    docedit() {
        //this.PrimaryDoctorO = false;
        //this.PrimaryDoctorn = true;

        const modalRef = this.modalService.open(NgbSearchProviderModal,
            {
                centered: true,
                size: 'lg',
                backdrop: 'static',
                keyboard: false
            })
        modalRef.componentInstance.IsShowDoctor = true;
        modalRef.componentInstance.DoctorType = 'All';
        modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
            this.Prescribername = receivedEntry.make;
            this.Prescribercode = receivedEntry.value;
            this.Prescriberdesg = receivedEntry.desg;
            this.CurrentPrescribingDoctor = null;
            this.LoadDoctorPres();

            // this.Refcode = this.SelectedPatientFormattedCode.RefCode;
            //this.Refdesg = this.CurrentDoctorsListController.filter(X => X.DisplayName == this.SelectedPatientFormattedCode.RefDetails)[0].Specialty;
            //this.Refname = this.SelectedPatientFormattedCode.RefDetails;
            //this.LoadDoctorRef();

            //this.PrimaryNumber = receivedEntry.number;
            // this.CurrentSavePatientInfoRequest.PrimaryDoctor = this.PrimaryDoctor;
            //alert(this.ProviderName);
        })
    }
    CancelNewOperation() {

        this.ShowList = true;
    }
    back() {
        this.receipt = false;
        this.opbilling = true;
        this.router.navigate(['/healins/opbilling']);
        //this.router.navigate.['/healins/opbilling'];
    }
    payment() {
        const modalRef = this.modalService.open(NgbPayBillModal,
            {
                centered: true,
                size: "lg"
            })
    }
    private stopRefreshing() {
        this.loaderService.displayLoader(false);
        this.isRequesting = false;
    }
    private StartRefreshing() {
        this.loaderService.displayLoader(true);
        this.isRequesting = true;
    }

    CurrentOrderData: Array<OrderData>;
    AddRow(l: ServicesByCategoryCodeController) {
        if (this.CurrentOrderData == null) {
            this.CurrentOrderData = new Array<OrderData>();
        }
        if (this.CurrentOrderData != null) {
            var row = new OrderData();
            row.Edit = false;
      
            row.RowNumber = row.RowNumber + 1;
            row.ItemName = l.ServiceName;
            row.Quantity = 1;
            row.UnitPrice = l.BasePrice;
           
            row.ItemRate = l.BasePrice * row.Quantity;
            row.ItemGroup = l.Servicecategory;
            row.AssignedTo = 0;
            row.AssignedToName = "";
            row.ItemCode = l.Code;
            row.ItemType = l.CategoryName;
            row.Pack = l.ServiceName;
            row.Uom = l.BasePrice;
            row.ScheduledDate = new Date();
            row.ScheduledTime = Date.now().toString();

           // row.PackageName = l.CategoryName;
           // row.DiscountAllowed = l.DiscountAllowed;
            //row.ChargeItemCode = 0;
            this.CurrentOrderData.push(row);

        }

        this.TotalBill = this.CurrentOrderData.filter((item) => item.ItemRate)
            .map((item) => +item.ItemRate)
            .reduce((sum, current) => sum + current);
        this.NetPayable = this.CurrentOrderData.filter((item) => item.ItemRate)
            .map((item) => +item.ItemRate)
            .reduce((sum, current) => sum + current);
        this.BranchName = AppData.Instance().SelectedBranchName;
        this.Date = new Date();
        //        alert(l.BasePrice);

        //this.AddData();

    }
    CurrentNewBillData: NewBillData;

    //AddData() {
    //    this.CurrentNewBillData = new NewBillData();
    //    this.CurrentNewBillData.ActorCode = this.SelectedPatientFormattedCode.ActorCode;
        

    //    this.CurrentNewBillData.BillDate = new Date();
    //    this.CurrentNewBillData.BillSource = "Internal";
    //    this.CurrentNewBillData.BillStatus = "";
    //    this.CurrentNewBillData.BillType = "OP";
    //    this.CurrentNewBillData.BranchCode = AppData.Instance().SelectedBranchCode;
    //    this.CurrentNewBillData.BranchName = AppData.Instance().SelectedBranchName;
    //    this.CurrentNewBillData.ChargeEntryCode = 0;
    //    this.CurrentNewBillData.Gender = this.SelectedPatientFormattedCode.Gender;
    //    this.CurrentNewBillData.Items = this.CurrentBillDetails;
    //    this.CurrentNewBillData.PrescriberDoctor = this.SelectedPrescriber;
    //    this.CurrentNewBillData.ReferringDoctor = this.SelectedReferral;
    //    this.CurrentNewBillData.PatientFormattedCode = this.SelectedPatientFormattedCode.FormattedCode;
    //    this.CurrentNewBillData.PatientName = this.SelectedPatientFormattedCode.DisplayName;
    //    this.CurrentNewBillData.PhoneNumber = this.SelectedPatientFormattedCode.Telephone1;
    //    this.CurrentNewBillData.TotalDiscount = 0;
    //    this.CurrentNewBillData.TotalBill = this.CurrentBillDetails.filter((item) => item.ItemRate)
    //       .map((item) => +item.ItemRate)
    //        .reduce((sum, current) => sum + current);
    //    this.CurrentNewBillData.NetPayable = this.CurrentBillDetails.filter((item) => item.ItemRate)
    //      .map((item) => +item.ItemRate)
    //        .reduce((sum, current) => sum + current);
    //    //this.CurrentNewBillData
    //    this.SaveData();
       

    //}

    SaveData() {
        this.CurrentSaveBillItemsInfoRequest.Bill = this.CurrentNewBillData;
        this.CurrentSaveBillItemsInfoRequest.ChargeEntry = "0";
        this.CurrentSaveBillItemsInfoRequest.ConditionalOperator = 10;
        this.actorservice.SaveBillItemsInfo(this.CurrentSaveBillItemsInfoRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.GetActorEducationInfoController();
                        //this.GetResourceIdentificationByDateInfoController();
                        // alertFunctions.AlertParam('Saved Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                       // this.Listview = true;
                        //this.EditEmbryo = false;
                        //this.LoadStoreData();
                        //this.AddEmbryo = false;
                        //this.spinner.hide();
                        //this.activeModal.close();
                        //this.clearData();
                        // this.LoadScansData();
                        this.stopRefreshing();

                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");

                        //this.spinner.hide();
                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                        alert(this.ApiResData.ErrorData);


                    }
                    else {
                        //this.spinner.hide();
                        this.stopRefreshing();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                       // this.spinner.hide();
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                       // this.spinner.hide();
                        this.stopRefreshing();
                    }
                }
            );
    }
    SaveData2() {
        this.CurrentSaveiahOrderRequest.ConditionalOperator = 10;
        this.CurrentSaveiahOrderRequest.Branch = AppData.Instance().SelectedBranchCode;
        this.CurrentSaveiahOrderRequest.OrderType = this.OrderType;
        this.CurrentSaveiahOrderRequest.CreatedUser = AppData.Instance().SelectedBranchName;
        this.CurrentSaveiahOrderRequest.CustomerActorCode = this.SelectedPatientFormattedCode.ActorCode;
        this.CurrentSaveiahOrderRequest.CustomerName = this.SelectedPatientFormattedCode.DisplayName;
        this.CurrentSaveiahOrderRequest.IahOrderCode = 0;
        this.CurrentSaveiahOrderRequest.ActorCode = this.SelectedPatientFormattedCode.ActorCode;
        this.CurrentSaveiahOrderRequest.MobileNumber = this.SelectedPatientFormattedCode.Telephone1;
        this.CurrentSaveiahOrderRequest.Mail = this.SelectedPatientFormattedCode.Email;
        this.CurrentSaveiahOrderRequest.OrderDate = new Date();
        this.CurrentSaveiahOrderRequest.DeliveryAddress = this.SelectedPatientFormattedCode.AddressLine1 + "," + this.SelectedPatientFormattedCode.AddressLine2 + "," + this.SelectedPatientFormattedCode.City + "," + this.SelectedPatientFormattedCode.State + "," + this.SelectedPatientFormattedCode.County + "," + this.SelectedPatientFormattedCode.ZipCode;
        this.CurrentSaveiahOrderRequest.OrderItems = this.CurrentOrderData;
        this.CurrentSaveiahOrderRequest.OrderSource = AppData.Instance().UserLoginDetails.UserName;
        this.CurrentSaveiahOrderRequest.PrescriberDoctor = this.CurrentPrescribingDoctor;
        this.CurrentSaveiahOrderRequest.ReferringDoctor = this.CurrentReferringDoctor;
       
        this.CurrentSaveiahOrderRequest.TotalBill = this.CurrentOrderData.filter((item) => item.ItemRate)
            .map((item) => +item.ItemRate)
            .reduce((sum, current) => sum + current);
        this.CurrentSaveiahOrderRequest.NetPayable = this.CurrentOrderData.filter((item) => item.ItemRate)
            .map((item) => +item.ItemRate)
            .reduce((sum, current) => sum + current);
        this.actorservice.SaveiahOrder(this.CurrentSaveiahOrderRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.GetActorEducationInfoController();
                        //this.GetResourceIdentificationByDateInfoController();
                        // alertFunctions.AlertParam('Saved Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                        // this.Listview = true;
                        //this.EditEmbryo = false;
                        //this.LoadStoreData();
                        //this.AddEmbryo = false;
                        //this.spinner.hide();
                        //this.activeModal.close();
                        //this.clearData();
                        // this.LoadScansData();
                        this.stopRefreshing();
                        if (this.OrderType == "Home") {
                            this.router.navigate(['healins/iohorders']);
                        }
                        else {
                            this.router.navigate(['healins/profileview', { FormattedCode: this.SelectedPatientFormattedCode.FormattedCode, DisplayName: this.SelectedPatientFormattedCode.DisplayName, title: "cycle" }]);
                        }
                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");

                        //this.spinner.hide();
                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                        alert(this.ApiResData.ErrorData);


                    }
                    else {
                        //this.spinner.hide();
                        this.stopRefreshing();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        // this.spinner.hide();
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        // this.spinner.hide();
                        this.stopRefreshing();
                    }
                }
            );
    }
    Cancel() {

        if (this.OrderType == "Home") {
            this.router.navigate(['healins/iohorders']);
        }
        else {
            this.router.navigate(['healins/profileview', { FormattedCode: this.SelectedPatientFormattedCode.FormattedCode, DisplayName: this.SelectedPatientFormattedCode.DisplayName, title: "cycle" }]);
        }
    }
    //alert(this.CurrentBillDetails.length);
    // CurrentBillDetailsEdit: BillDetails;
    Editrow(l: BillDetails) {
        //this.Add = false;

        //this.Edit = true;
        l.Edit = true;
        //this.CurrentBillDetailsEdit = new BillDetails();
        //this.CurrentBillDetailsEdit.rownumber = l.rownumber;
        //this.CurrentBillDetailsEdit.ServiceDescription = l.ServiceDescription;
        //this.CurrentBillDetailsEdit.quantity = l.quantity;
        //this.CurrentBillDetailsEdit.unitprice = l.unitprice;
        //this.CurrentBillDetailsEdit.discount = l.discount;
        //this.CurrentBillDetailsEdit.ItemRate = l.ItemRate;

    }
    delete(i:number) {
        swal({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#0CC27E',
            cancelButtonColor: '#FF586B',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            confirmButtonClass: 'btn btn-success btn-raised mr-5',
            cancelButtonClass: 'btn btn-danger btn-raised',
            allowOutsideClick: false,
            buttonsStyling: false
        }).then(() => {

            //this.deleterow(i);

            //this.DeleteActorIdentitiesMedicine(l);
            // alertFunctions.AlertParam('Delete Successfully...!');

        }, function (dismiss) {
            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
            if (dismiss === 'cancel') {
                swal(
                    'Cancelled',
                    'Saving Operation Cancelled :)',
                    'error'
                )
            }
        })

    }
    //deleterow(i: number) {
    //    this.CurrentBillDetails.splice(i);
        
    //}
    OnClear(l: BillDetails) {
        l.Edit = false;
    }
    //Payment() {
    //    const modalRef = this.modalService.open(NgbPaymentModal,
    //        {
    //            centered: true,
    //            size: "lg"
               
    //        })
    //    modalRef.componentInstance.FormattedCode = this.CurrentPatientInfoByFormattedCodeController[0].FormattedCode;
    //    modalRef.componentInstance.PatientImage = this.CurrentPatientInfoByFormattedCodeController[0].PatientImageFile;
    //    modalRef.componentInstance.PatientName = this.CurrentPatientInfoByFormattedCodeController[0].DisplayName;
    //    modalRef.componentInstance.Age = this.CurrentPatientInfoByFormattedCodeController[0].Age;
    //    modalRef.componentInstance.Gender = this.CurrentPatientInfoByFormattedCodeController[0].Gender;
    //    modalRef.componentInstance.Telephone1 = this.CurrentPatientInfoByFormattedCodeController[0].Telephone1;
    //    modalRef.componentInstance.BillDate = this.CurrentNewBillData.BillDate;
    //    modalRef.componentInstance.TotalBill = this.CurrentNewBillData.TotalBill;
    //    modalRef.componentInstance.NetPayable = this.CurrentNewBillData.NetPayable;
    //    modalRef.componentInstance.Discount = this.CurrentNewBillData.TotalDiscount;
    //    modalRef.componentInstance.ActorCode = this.CurrentNewBillData.ActorCode;
    //    modalRef.componentInstance.ChargeEntryCode = this.CurrentNewBillData.ChargeEntryCode;
    //    modalRef.componentInstance.BillStatus = this.CurrentNewBillData.BillStatus;
    //    modalRef.componentInstance.BillType = this.CurrentNewBillData.BillType;
    //    modalRef.componentInstance.BillSource = this.CurrentNewBillData.BillSource;
    //    modalRef.componentInstance.BranchName = this.CurrentNewBillData.BranchName;
    //    modalRef.componentInstance.BranchCode = this.CurrentNewBillData.BranchCode;
    //    modalRef.componentInstance.ItemsSelected = this.CurrentBillDetails;

    //    modalRef.componentInstance.Prescriber = this.SelectedPrescriber;
    //    modalRef.componentInstance.Refferal = this.SelectedReferral;

    //}


}
//export class BillDetails {
//    public ServiceDescription: string;
//    public Quantity: number;
//    public UnitPrice: number;
//    public Discount: number;
//    public ItemRate: number;
//    public RowNumber: number;
//    public Edit: boolean;
//    public ServiceCode: number;
//    public ItemType: string;
//    public ItemGroup: string;
//    public GroupName: string;
//    public IsPackage: boolean;
//    public PackageName: string;
//    public ChargeItemCode: number;
//    public DiscountAllowed: boolean;

//}

//export class PrescribingDoctor {
//    public DoctorName: string;
//    public DoctorCode: number;
//    public Designation: string;
//}
//export class ReferringDoctor {
//    public DoctorName: string;
//    public DoctorCode: number;
//    public Designation: string;
//}

